import React, { forwardRef, ReactNode } from 'react'
import styles from 'styles/components/typography.module.scss'
import { FlexRow } from 'components/Flex'

type Props = {
  headline: string
  iconPath?: string
  prevIcon?: ReactNode
  nextIcon?: ReactNode
  size?: 'small' | 'medium'
}

const TopHeadline = forwardRef<HTMLHeadingElement, Props>((props, ref) => {
  const { headline, iconPath, prevIcon, nextIcon, size } = props

  const innerClass = (() => {
    switch (size) {
      case 'small':
        return styles.headline__top__inner_small
      case 'medium':
        return styles.headline__top__inner
      default:
        return styles.headline__top__inner
    }
  })()

  const textClass = (() => {
    switch (size) {
      case 'small':
        return styles.headline__top__text_small
      case 'medium':
        return styles.headline__top__text
      default:
        return styles.headline__top__text
    }
  })()

  return (
    <div className={styles.headline__top}>
      <div className={innerClass}>
        {prevIcon && prevIcon}
        <FlexRow alignItems="center" justifyContent="start" flex={1} gap={3}>
          {iconPath && <img className={styles.headline__top__icon} src={iconPath} alt={headline} />}
          <h1 className={textClass} data-cy={'top-headline'} ref={ref}>
            {headline}
          </h1>
        </FlexRow>
        {nextIcon && nextIcon}
      </div>
    </div>
  )
})

export default TopHeadline
